// Auctions landing page (sections/auctions-*.liquid) — everything EXCEPT the countdown timer
// and sold-lots feed, which are still handled entirely by the existing assets/auctions.js
// (loaded separately by sections/auctions-hero.liquid / auctions-recent-lots.liquid). This file
// only covers the FAQ accordion, the dynamic "+ Add a bottle" valuation form fields, and the
// stats band's once-only fade-up entrance.
(() => {
  if (window.__auctionsLandingInitialized) return;
  window.__auctionsLandingInitialized = true;

  const CHEVRON_SVG =
    '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initFaq() {
    document.querySelectorAll('[data-faq-item]').forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      const chevron = item.querySelector('[data-faq-chevron]');
      if (!trigger || !panel) return;
      chevron.innerHTML = CHEVRON_SVG;

      trigger.addEventListener('click', () => {
        const expand = item.dataset.expanded !== 'true';
        document.querySelectorAll('[data-faq-item][data-expanded="true"]').forEach((other) => {
          if (other === item) return;
          setFaqExpanded(other, false);
        });
        setFaqExpanded(item, expand);
      });
    });

    function setFaqExpanded(item, expand) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      item.dataset.expanded = expand ? 'true' : 'false';
      trigger.setAttribute('aria-expanded', expand ? 'true' : 'false');
      panel.style.maxHeight = expand ? `${panel.scrollHeight}px` : '0px';
    }
  }

  function initValuationForm() {
    const form = document.querySelector('[data-valuation-form]');
    if (!form) return;
    const bottlesWrap = form.querySelector('[data-valuation-bottles]');
    const addButton = form.querySelector('[data-valuation-add-bottle]');
    if (!bottlesWrap || !addButton) return;

    let bottleCount = bottlesWrap.querySelectorAll('[data-valuation-bottle]').length;

    function addPhotoNoteToggle(row) {
      const input = row.querySelector('input');
      const update = () => row.classList.toggle('valuation-form__bottle--has-value', input.value.trim().length > 0);
      input.addEventListener('input', update);
      update();
    }

    function addRemoveHandler(row) {
      const removeButton = row.querySelector('[data-valuation-remove-bottle]');
      if (!removeButton) return;
      removeButton.addEventListener('click', () => row.remove());
    }

    function addBottleRow() {
      bottleCount += 1;
      const row = document.createElement('div');
      row.className = 'valuation-form__bottle';
      row.dataset.valuationBottle = '';
      row.innerHTML = `
        <div class="valuation-form__bottle-row">
          <input type="text" name="contact[Bottle ${bottleCount}]" placeholder="Bottle ${bottleCount} — describe it (distillery, age, bottling)">
          <button type="button" class="valuation-form__remove-bottle" data-valuation-remove-bottle aria-label="Remove this bottle">&times;</button>
        </div>
        <span class="valuation-form__photo-note">📷 You can email photos separately, referencing this enquiry</span>
      `;
      bottlesWrap.appendChild(row);
      addPhotoNoteToggle(row);
      addRemoveHandler(row);
    }

    bottlesWrap.querySelectorAll('[data-valuation-bottle]').forEach((row) => {
      addPhotoNoteToggle(row);
      addRemoveHandler(row);
    });
    addButton.addEventListener('click', addBottleRow);
  }

  function initStatsFadeUp() {
    const stats = document.querySelectorAll('[data-stat]');
    if (!stats.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stats.forEach((stat) => stat.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = Array.from(stats).indexOf(entry.target);
          entry.target.style.transitionDelay = `${Math.max(index, 0) * 90}ms`;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );

    stats.forEach((stat) => observer.observe(stat));
  }

  // Auto-cycling review slider (above the FAQ) — one review visible at a time, cross-fading on
  // a timer, with clickable dots for manual navigation. Pauses on hover so a reader mid-review
  // isn't interrupted, and pauses entirely for prefers-reduced-motion (first review stays put,
  // still fully readable — nothing here is otherwise inaccessible).
  function initTestimonialSlider() {
    const slider = document.querySelector('[data-testimonial-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-testimonial-track]');
    const dotsWrap = slider.querySelector('[data-testimonial-dots]');
    const slides = Array.from(slider.querySelectorAll('[data-testimonial-slide]'));
    if (!track || slides.length < 2) return;

    const intervalMs = Math.max(parseInt(slider.dataset.testimonialInterval, 10) || 6000, 3000);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;

    const dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonial-slider__dot';
      dot.setAttribute('aria-label', `Show review ${i + 1} of ${slides.length}`);
      dot.addEventListener('click', () => {
        goTo(i);
        restart();
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function syncHeight() {
      track.style.height = `${slides[index].offsetHeight}px`;
    }

    function show(i) {
      slides.forEach((slide, si) => slide.classList.toggle('is-active', si === i));
      dots.forEach((dot, di) => dot.classList.toggle('is-active', di === i));
      syncHeight();
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      show(index);
    }

    function start() {
      if (reducedMotion) return;
      stop();
      timer = window.setInterval(() => goTo(index + 1), intervalMs);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function restart() {
      start();
    }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    window.addEventListener('resize', syncHeight);

    show(0);
    start();
  }

  // The process circles start as a gold outline with a plain (unfilled) number and no
  // connecting line — once the section scrolls into view, the circles fill in sequence (1, 2,
  // 3, 4) via a staggered transition-delay, and the connecting line grows left-to-right over
  // roughly the same span, so it visually "reaches" each circle right as it fills.
  function initProcessReveal() {
    const grid = document.querySelector('[data-process-grid]');
    if (!grid) return;
    const circles = grid.querySelectorAll('[data-process-circle]');
    if (!circles.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      grid.classList.add('is-active');
      circles.forEach((circle) => circle.classList.add('is-filled'));
      return;
    }

    circles.forEach((circle, index) => {
      circle.style.transitionDelay = `${300 + index * 300}ms`;
    });

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          grid.classList.add('is-active');
          circles.forEach((circle) => circle.classList.add('is-filled'));
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(grid);
  }

  // Cross-page links (the header's Auctions mega-menu "Sell your Whisky" item) land here as
  // /pages/auctions#auctions-process — the browser's own instant hash-jump on page load looks
  // abrupt, and lands the section flush under the header with no clearance. Overriding with an
  // explicit smooth scrollIntoView, offset by the header's own live height, fixes both.
  function initHashScroll() {
    if (window.location.hash !== '#auctions-process') return;
    const target = document.querySelector('#auctions-process');
    if (!target) return;

    requestAnimationFrame(() => {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const targetY = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    });
  }

  // Aligns the stats-band and valuation-form background images (see .band__media--seam in
  // section-auctions-landing.css) so they read as one continuous photo instead of two
  // independently-centered crops of the same source image. Both sections are full-bleed and
  // width-constrained, so a plain "cover" crop gives them the SAME zoom level but centers each
  // one independently — meaning both show near-identical, heavily overlapping slices rather than
  // a continuation. Forcing an explicit shared background-size (tall enough to cover both
  // sections' combined height) plus a background-position offset on the lower section equal to
  // the upper section's own height makes the lower slice pick up exactly where the upper one
  // left off.
  function initAuctionsSeamBackground() {
    const statsSection = document.querySelector('.stats-section.band--media');
    const valuationSection = document.querySelector('.valuation-section.band--media');
    if (!statsSection || !valuationSection) return;

    const statsMedia = statsSection.querySelector('[data-seam-media="stats"]');
    const valuationMedia = valuationSection.querySelector('[data-seam-media="valuation"]');
    if (!statsMedia || !valuationMedia) return;

    function apply() {
      if (window.innerWidth < 750) {
        // Mobile layout reflows too much for a stable seam to be worth chasing — fall back to a
        // normal independent crop per section (same photo, just not pixel-aligned).
        statsMedia.style.backgroundSize = 'cover';
        statsMedia.style.backgroundPosition = 'center center';
        valuationMedia.style.backgroundSize = 'cover';
        valuationMedia.style.backgroundPosition = 'center center';
        return;
      }

      const statsHeight = Math.ceil(statsSection.getBoundingClientRect().height);
      const valuationHeight = Math.ceil(valuationSection.getBoundingClientRect().height);
      const combinedSize = 'auto ' + (statsHeight + valuationHeight) + 'px';

      statsMedia.style.backgroundSize = combinedSize;
      statsMedia.style.backgroundPosition = 'center top';

      valuationMedia.style.backgroundSize = combinedSize;
      valuationMedia.style.backgroundPosition = 'center -' + statsHeight + 'px';
    }

    apply();
    window.addEventListener('resize', apply);
  }

  function init() {
    initFaq();
    initValuationForm();
    initStatsFadeUp();
    initProcessReveal();
    initTestimonialSlider();
    initHashScroll();
    initAuctionsSeamBackground();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
